module.exports = "<headerMenu></headerMenu>\r\n<app-sharepromotionalcode></app-sharepromotionalcode>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/sharepromotionalcodecontainer/sharepromotionalcodecontainer.component.html
// module id = ./src/app/dash-board/sharepromotionalcodecontainer/sharepromotionalcodecontainer.component.html
// module chunks = main